import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import Header from '../../components/header';
import { COLLEGE_SEMESTERS } from '../../utils/semesterDefaults';

import Alert from "../../components/alert";
import Preloader from '../../components/preloader';
function AddAttendence() {
    const today = new Date();
    const fulldate = today.toISOString().split('T')[0];
    const [semesters, setSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState('');
    const [students] = useState({});
    const [attendance, setAttendance] = useState({});

    const [alertVisible, setAlertVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
        
        getDocs(subjectsRef).then(snapshot => {
            if (snapshot.empty) {
                // Use fallback semesters if no subjects found
                setSemesters(COLLEGE_SEMESTERS);
            } else {
                const uniqueSemesters = [...new Set(snapshot.docs.map(doc => doc.data().semester))];
                setSemesters(uniqueSemesters.length > 0 ? uniqueSemesters : COLLEGE_SEMESTERS);
            }
        }).catch(err => {
            console.error('Error fetching semesters:', err);
            setSemesters(COLLEGE_SEMESTERS);
        });
    }, []);

    useEffect(() => {
        if (selectedSemester) {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(
                collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                where('semester', '==', selectedSemester)
            );
            getDocs(q).then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data());
                setSubjects(data);
            });
        }
    },
        [selectedSemester]);

    const checksubject = (key) => {
        // eslint-disable-next-line no-useless-escape
        return key.replace(/[./#$\[\]]/g, '_');
    };
    console.log(students);

    const handleAttendanceChange = (id, value) => {
        const checkedsub = checksubject(selectedSubject);
        console.log(checkedsub);

        setAttendance((prev) => ({
            ...prev,
            [id]: {
                ...(prev[id]),
                Attendance: {
                    [selectedSemester]: {
                        ...(prev[id]?.Attendance?.[selectedSemester]),
                        [checkedsub]: {
                            ...(prev[id]?.Attendance?.[selectedSemester]?.[checkedsub]),
                            date: fulldate,
                            Status: value,
                        }
                    }
                }
            }
        }));
    };

    const submitForm = async (e) => {
        e.preventDefault();
        setLoading(true);
        const checkedsub = checksubject(selectedSubject);
        console.log(checkedsub);
        try {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) {
                setLoading(false);
                return;
            }
            
            // Batch update attendance for all students
            for (const student of students) {
                const studentRef = doc(db, 'institutions', loggedUser.institution_id, 'attendance', student.id);
                await updateDoc(studentRef, {
                    [selectedSemester]: {
                        [selectedSubject]: {
                            date: fulldate,
                            Status: attendance[student.id]?.Attendance?.[selectedSemester]?.[checkedsub]?.Status || false
                        }
                    }
                });
            }

            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000);
            setTimeout(() => window.location.reload(), 3500);
        } catch (error) {
            console.error('Error updating attendance:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Update Attendance" />
            {alertVisible && <Alert message="Form submitted successfully!" />}
            {loading && <Preloader />}
            <form id="attendanceForm" onSubmit={submitForm} className="col-12 p-5">
                <p>Today: {fulldate}</p>
                <div className='row'>
                    <div className="form-group form-floating col-5">
                        <select aria-label="Floating label select example" required id="semester" className="form-select" value={selectedSemester} onChange={(e) =>
                            setSelectedSemester(e.target.value)
                        }

                        >
                            <option value="" selected>
                                -----------
                            </option>
                            {semesters.map((semester) => (
                                <option key={semester} value={semester}>
                                    {semester}
                                </option>
                            ))}
                        </select>
                        <label htmlFor="floatingSelect">Select Semester:</label>
                    </div>

                    {subjects.length > 0 ? (
                        <div className="form-group form-floating ms-3 col-5">
                            <select required id="subject floatingSelect" className="form-select" aria-label="Floating label select example" value={selectedSubject} onChange={
                                (e) => setSelectedSubject(e.target.value)
                            } >
                                <option value="">
                                    -----------
                                </option>
                                {subjects.map((subject) => (
                                    <option key={subject.id} value={subject.subject}>
                                        {subject.subject}
                                    </option>
                                ))}
                            </select>
                            <label htmlFor="floatingSelect">Select Subject:</label>
                        </div>
                    ) : (
                        <p className="text-info-emphasis p-3">Select Semester</p>
                    )}

                    {selectedSubject ? (
                        <><table className="table table-hover table-responsive text-center mt-4">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Roll No</th>
                                    <th scope="col">{selectedSubject} Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(students).length > 0 ? (
                                    Object.keys(students).map((student) => (
                                        <tr key={students[student].rollNo}>
                                            <td>{students[student].Name}</td>
                                            <td>{students[student].rollNo}</td>
                                            <td>
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="radio"

                                                        id={students[student].rollNo}
                                                        name={students[student].rollNo}
                                                        value="present"
                                                        className="form-check-input"
                                                        onChange={() => handleAttendanceChange(student, 'present')} />
                                                    <label className="form-check-label" htmlFor={students[student].rollNo}>
                                                        Present
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="radio"
                                                        id={students[student].rollNo}
                                                        name={students[student].rollNo}
                                                        value="absent"
                                                        className="form-check-input"
                                                        onChange={() => handleAttendanceChange(student, 'absent')} />
                                                    <label className="form-check-label" htmlFor={students[student].rollNo}>
                                                        Absent
                                                    </label>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            Loading data...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                            <button type="submit" className="btn col-3 btn-success text-uppercase">
                                Submit Attendance
                            </button>
                        </>
                    ) : (selectedSemester ? (
                        <p className="text-info-emphasis p-3">Select Subject</p>
                    )
                        : ("")
                    )}
                </div>
            </form>
        </Layout>
    );
}

export default AddAttendence;
